import PlayPageLayout from './PlayPageLayout';

export default PlayPageLayout;